import { defineStore } from "pinia";
// @ts-expect-error don't know why....
import { useRegisterSW } from "virtual:pwa-register/vue";
import { computed, ref } from "vue";

export const useAppStore = defineStore('app', () => {
  const { needRefresh, updateServiceWorker } = useRegisterSW();
  const installPrompt = ref();

  const installable = computed(() => !!installPrompt.value);

  window.addEventListener('beforeinstallprompt', (ev) => {
    ev.preventDefault();
    installPrompt.value = ev;
  })

  async function install() {
    if(installPrompt.value) {
      const { outcome } = await installPrompt.value.prompt();
      if(outcome == 'accepted') installPrompt.value = undefined;
    }
  }

  return {
    installable,
    needRefresh,
    install,
    update: updateServiceWorker
  };
});
